// A slide-down notification bar with a "Dismiss" button
import $ from "jquery";
import * as _ from "underscore";

let notificationBar;
let options;
let timeout;
let hiddenCSS;

export const showMessage = (_options) => {
  options = _.pick(_options, [
    "message",
    "htmlMessage",
    "css",
    "above",
    "element",
    "extraCss",
    "time",
    "onDismiss",
    "callback",
  ]);

  if (notificationBar) {
    notificationBar.remove();
  }

  notificationBar = $(`<div class=notification>
  <p class=message></p>
  <button class="dismissButton" aria-label="Dismiss">×</button>
</div>
`);

  // `message` is rendered as text, never parsed as HTML: the bookmarklet's
  // "notify" command reaches this sink from a cross-origin postMessage whose
  // sender cannot be authenticated (see messagingUtils.messageListener), so a
  // hostile parent framing readlang.com could otherwise get an <img onerror>
  // payload executing on our own origin. `htmlMessage` stays raw for markup the
  // app composes itself, and must never be fed from a message field.
  notificationBar
    .find(".message")
    .text(options.message ?? "")
    .append(options.htmlMessage ?? "");

  if (options.css) {
    notificationBar.css(options.css);
  }

  const height = 100;

  let shownCSS;

  if (options.above) {
    hiddenCSS = { top: -height };
    shownCSS = { top: 0 };
  } else {
    hiddenCSS = { bottom: -height };
    shownCSS = { bottom: 0 };
  }

  if (options.element) {
    options.element.append(notificationBar);
  } else {
    $("#entirePage").append(notificationBar).removeClass("pageLoading");
    hiddenCSS.position = "fixed";
    shownCSS.position = "fixed";
  }

  notificationBar.css(hiddenCSS).css({ display: "block" });
  if (options.extraCSS) {
    notificationBar.css(options.extraCSS);
  }

  try {
    notificationBar.animate(shownCSS);
  } catch (_err) {
    // Ignore error. Need try-catch because it crashes on Firefox 23.0.1 - don't ask why
    // the animation works fine despite the crash
  }

  notificationBar.find(".dismissButton").click(dismiss);
  timeout = setTimeout(dismiss, options.time || 5000);
  if (options.callback) {
    options.callback();
  }
};

/** Whether the bar shown is the one with `message` */
export const isShowing = (message: string) =>
  Boolean(notificationBar) && options?.message === message;

export const dismiss = () => {
  if (!options || !notificationBar) {
    return;
  }
  if (options.onDismiss) {
    options.onDismiss();
  }
  clearTimeout(timeout);
  notificationBar.animate(hiddenCSS, {
    complete: function () {
      if (notificationBar) {
        notificationBar.remove();
        notificationBar = undefined;
      }
    },
  });
};
